export const fontColor='rgba(255, 255, 255, 0.87)'